"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';

const itemNestedIndicatorRecipe = tv({
  slots: withSlotScopeClasses("item-nested-indicator", {
    wrapper: "flex items-center",
    "children-counter": "flex justify-center items-center w-4 h-4 text-slate-11 text-sm leading-5",
    "counter-hidden-title": "sr-only"
  })
});
const pluralRules = new Intl.PluralRules("en");
const pluralForms = {
  one: " child",
  other: " children"
};
function ItemNestingIndicator({ count, children }) {
  const styles = itemNestedIndicatorRecipe();
  return /* @__PURE__ */ jsxs("div", { className: styles.wrapper(), children: [
    !!count && /* @__PURE__ */ jsxs("span", { className: styles["children-counter"](), children: [
      count,
      /* @__PURE__ */ jsx("span", { className: styles["counter-hidden-title"](), children: pluralForms[pluralRules.select(count)] })
    ] }),
    children
  ] });
}

export { ItemNestingIndicator };
